import React, { useState, useEffect, useContext } from "react";
import TableCellRegressionDiff from "../table/TableCellRegressionDiff";
import Utils from "../../utils/Utils";
import TableCellRank from "../table/TableCellRank";
import TableSkeleton from "../table/TableSkeleton";
import { authGetRequest } from "../../utils/authGetRequest";
import { AppContext } from "../../context/state";

const tableHeader = [
  {
    title: "ShotType Stats",
    showImage: false,
    sortable: false,
    key: "ShotTypeStats",
  },
];

export const TeamStats = ({ opponentName, token, teamName, isPremiumPlan, leagueFromUrl }) => {
  const rankConfig = {
    leagueType: "college_mens",
    conferenceTeamCount: 0,
  };
  const { store } = useContext(AppContext);
  const [tableLoaded, setTableLoaded] = useState(null);
  const [team1, setTeam1] = useState(null);
  const [team2, setTeam2] = useState(null);

  useEffect(() => {
    if (token) {
      authGetRequest(
        `/api/${
          leagueFromUrl === "ncaa" ? "college_mens" : leagueFromUrl === "ncaaw" ? "college_womens" : leagueFromUrl
        }/${teamName}/records`,
        token
      )
        .then((response) => response.data)
        .then((response) => {
          setTeam1(response.data);
        })
        .catch((err) => {
          // setTableLoaded(false);
          console.log(err);
        });

      authGetRequest(
        `/api/${
          leagueFromUrl === "ncaa" ? "college_mens" : leagueFromUrl === "ncaaw" ? "college_womens" : leagueFromUrl
        }/${opponentName}/records`,
        token
      )
        .then((response) => response.data)
        .then((response) => {
          setTeam2(response.data);
        })
        .catch((err) => {
          // setTableLoaded(false);
          console.log(err);
        });
    } else {
      authGetRequest(
        `/api/${
          leagueFromUrl === "ncaa" ? "college_mens" : leagueFromUrl === "ncaaw" ? "college_womens" : leagueFromUrl
        }/${teamName}/records/unprotected/homepage`,
        token
      )
        .then((response) => response.data)
        .then((response) => {
          setTeam1(response.data);
        })
        .catch((err) => {
          // setTableLoaded(false);
          console.log(err);
        });

      authGetRequest(
        `/api/${
          leagueFromUrl === "ncaa" ? "college_mens" : leagueFromUrl === "ncaaw" ? "college_womens" : leagueFromUrl
        }/${opponentName}/records/unprotected/homepage`,
        token
      )
        .then((response) => response.data)
        .then((response) => {
          setTeam2(response.data);
        })
        .catch((err) => {
          // setTableLoaded(false);
          console.log(err);
        });
    }
  }, [token]);
  useEffect(() => {
    if (team1?.length && team2?.length) {
      (async () => {
        let data = await team1.map((team) => {
          team2.forEach((opponent) => {
            if (team.Name == opponent.Name) {
              team.opponent = opponent;
            }
          });
          return team;
        });
        setTableLoaded(data);
      })();
    }
  }, [team1, team2, token]);

  return (
    <>
      {!tableLoaded ? (
        <TableSkeleton
          tableHeader={tableHeader}
          tableRowsCount={10}
          className="table-space matchup-output-lazyloading"
          tableHeaderHeight="90px"
        ></TableSkeleton>
      ) : null}
      {tableLoaded ? (
        <>
          <table className="table tl-fixed-desktop">
            <tbody>
              <tr>
                <td className="d-flex justify-content-center" style={{ borderTopLeftRadius: "12px" }}>
                  <div className="teamLogoMiniWrapper" style={{ marginRight: "8px" }}>
                    <img src={`http://shotqualitybets.com/static/media/logos/${teamName}.png`} />
                  </div>
                </td>
                <td className="text-center">
                  <b>Team Stats</b>
                </td>
                <td className="d-flex flex-row-reverse justify-content-center" style={{ borderTopRightRadius: "12px" }}>
                  <div className="teamLogoMiniWrapper" style={{ marginLeft: "8px" }}>
                    <img src={`http://shotqualitybets.com/static/media/logos/${opponentName}.png`} />
                  </div>
                </td>
              </tr>

              {tableLoaded.map((record, i) =>
                isPremiumPlan || record.Name !== "SQ record" ? (
                  <tr key={`${teamName}_${record.Name}`} style={{ display: "table-row" }}>
                    <td className="text-center">{record.Value}</td>
                    <td className="text-center">{record.Name}</td>
                    <td className="text-center">{record.opponent.Value}</td>
                  </tr>
                ) : null
              )}
            </tbody>
          </table>
        </>
      ) : null}
    </>
  );
};
